<template>
  <!-- 投资机构活动框 -->
  <div class="InvestmentOrganization main">
    <DockingSystemTitle
      :title="'投资机构'"
      :moreType="true"
      :underlineType="false"
      :titleCenter="false"
    />

    <!-- 活动内容 -->

    <el-row class="ProjectContent">
      <InvestmentOrganizationProject :list="list" />
      <!-- <el-col
        class="project"
        :xs="24"
        :sm="6"
        v-for="(item, index) in list"
        :key="index"
      >
       
      </el-col> -->
    </el-row>

  </div>
</template>

<script>
import DockingSystemTitle from "@/components/DockingSystem/Title/DockingSystemTitle.vue"; //活动框title
import InvestmentOrganizationProject from "@/components/DockingSystem/ActivityFrame/InvestmentOrganizationProject.vue"; //投资机构项目
export default {
  props: {

    list:Array
  },
  components: {
    DockingSystemTitle,
    InvestmentOrganizationProject,
  },
  data() {
    return {
      list2: [
        {
          title: "IDG资本",
          logoUrl: "../../../../public/static/images/IDG-logo.png",
          site: "北京东城",
          notarize: "VC",
          investorNum: "35",
          caseNum: "477",
          content:
            "作为全球领先的投资机构，我们始终致力于利用全球丰富的资源和投资管理经验助力企业走向卓越。 IDG资本于1992年创立于美国波士顿， 1993年成为首家进入中国...",
        }
        
      ],
    };
  },
  created: function () {},
  methods: {},
};
</script>

<style scoped>
@media (max-width: 768px) {
  .InvestmentOrganization .ProjectContent{
    margin-left: 18px;
    margin-right: 0px;
  }
}
.InvestmentOrganization {
  margin-top: 34px;
  background-color: #262525;
  border-radius: 25px;
}
.ProjectContent {
  margin-left: 33px;
  margin-right: 15px;
  margin-top: 34px;
  padding-bottom: 26px;
}
/* .project{
    margin-right: 18px;
}

.ProjectContent > .project:nth-child(4n) {
    margin-right: 0px;
} */
</style>